
      <div class="main no-padding">
          <header-menu></header-menu>
          <company-report *ngIf="typeBusiness == 'company'"></company-report>
          <establishment-report *ngIf="typeBusiness == 'establishment'"></establishment-report>
      </div>
  